import loadable from '@loadable/component';

const Banners = loadable(
    () => import(/* webpackChunkName: "banners" */ './Banners.jsx')
);

export default Banners;
